import { Component, OnInit } from '@angular/core';
import { HomeNavigateBarComponent } from './modules/home/components/home-navigate-bar/home-navigate-bar.component';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  title = 'app';

  ngOnInit() {
    const ctor = $?.fn?.modal?.Constructor?.prototype;
    const method = ctor?._enforceFocus ? '_enforceFocus' : ctor?.enforceFocus ? 'enforceFocus' : null;
    if (!method) return;

    ctor[method] = function () {
      $(document).off('focusin.bs.modal').on('focusin.bs.modal', (e: any) => {
        if (!$(e.target).closest('.modal').length) {
          this._element?.focus?.() ?? this.$element?.trigger('focus');
        }
      });
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts